import { gql } from '@apollo/client';
import config from 'config';

const brandIndex = config.algolia.algolia_prefix + 'brands';
export const SEARCH_BRAND = gql`
    query searchBrand($input: searchBrandInput) {
        searchBrand(input: $input) {
            data {
                id
                creator
                created
                updater
                updated
                value
                name
                imageUrl
            }
        }
    }
`;
export const GET_BRAND_FROM_ALGOLIA = gql`
    query LocationsQuery(
        $query: String!
        $filters: String!
        $hit: Number!
        $page: Number!
        $facets: [String]!
    ) {
        getBrandFromAlgolia
            @algolia(
                __typename: "brandsAlgolia"
                index: ${brandIndex}
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
